import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertTriangle, FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmtBRL = (v) => `R$ ${Number(v || 0).toFixed(2).replace('.', ',')}`;

// Quadro de destaque: Dívidas Vencidas (contas a prazo sem pagamento há mais de 30 dias)
export const OverdueDebtsWidget = ({ colors, isLight, onOpenStatement }) => {
  const [data, setData] = useState({ count: 0, total: 0, total_with_interest: 0, items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/accounts/receivables/overdue/summary?min_days=30`, { withCredentials: true })
      .then((r) => setData(r.data))
      .catch(() => setData({ count: 0, total: 0, total_with_interest: 0, items: [] }))
      .finally(() => setLoading(false));
  }, []);

  const items = data.items || [];

  return (
    <div className="rounded-md p-5" style={{ background: colors.card, border: `1px solid ${colors.border}` }} data-testid="overdue-debts-widget">
      <div className="flex items-center justify-between mb-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-red-400">Inadimplência</p>
          <h3 className="text-lg font-bold mt-0.5" style={{ color: isLight ? '#0F172A' : '#FFFFFF' }}>Dívidas Vencidas (+30 dias)</h3>
        </div>
        <div className="p-2 rounded" style={{ background: 'rgba(248, 113, 113, 0.15)' }}>
          <AlertTriangle size={18} className="text-red-400" />
        </div>
      </div>

      <div className="flex items-end gap-6 mb-4">
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Total em atraso</p>
          <p className="text-3xl font-black text-red-500 tabular-nums" data-testid="overdue-total">{fmtBRL(data.total_with_interest || data.total)}</p>
        </div>
        <div>
          <p className="text-[10px] uppercase tracking-widest font-bold" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Contas</p>
          <p className="text-3xl font-black tabular-nums" style={{ color: isLight ? '#0F172A' : '#FFFFFF' }} data-testid="overdue-count">{data.count}</p>
        </div>
      </div>

      {loading ? (
        <p className="text-xs py-4 text-center" style={{ color: isLight ? '#64748B' : '#94A3B8' }}>Carregando...</p>
      ) : items.length === 0 ? (
        <p className="text-xs py-4 text-center text-emerald-500 font-medium" data-testid="overdue-empty">✓ Nenhuma dívida vencida há mais de 30 dias</p>
      ) : (
        <ol className="space-y-1.5" data-testid="overdue-list">
          {items.slice(0, 6).map((it, i) => (
            <li key={it.id || i} className="flex items-center gap-2 py-1.5 border-b last:border-0" style={{ borderColor: colors.border }}>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate" style={{ color: isLight ? '#0F172A' : '#F1F5F9' }}>{it.customer_name || '—'}</p>
                <p className="text-[10px] text-red-400 font-bold">{it.days_overdue} dias em atraso{it.sale_number ? ` · venda #${it.sale_number}` : ''}</p>
              </div>
              <span className="text-sm font-bold text-red-500 font-mono shrink-0">{fmtBRL(it.total_with_interest || it.amount)}</span>
              {it.customer_id && onOpenStatement && (
                <button
                  onClick={() => onOpenStatement(it.customer_id)}
                  className="shrink-0 p-1.5 rounded hover:bg-blue-500/20 text-blue-400"
                  title="Ver extrato"
                  data-testid={`overdue-statement-${it.customer_id}`}
                >
                  <FileText size={15} />
                </button>
              )}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};
